var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2559C24.8366 32.2559 32 25.0924 32 16.2559C32 7.4193 24.8366 0.255859 16 0.255859C7.16344 0.255859 0 7.4193 0 16.2559C0 25.0924 7.16344 32.2559 16 32.2559Z",
    fill: "#E4FAF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83105 15.8182L13.6561 20.6432L23.3051 10.9932",
    stroke: "#24DCAE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.e85ae4f599409b7ff05b6710ba25be86.svg";
export { ForwardRef as ReactComponent };